module.exports = {"primaryColor":"#353B4A","apiURL":"https://stagingapi.diyblinds.com.au","mediaURL":"https://stagingteammedia.diyblinds.com.au","install":false,"exGST":false,"motorization":true}


//////////////////
// WEBPACK FOOTER
// ./gConfigStaging.json
// module id = C27U
// module chunks = 1